// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const FaceMouthClosedOutlineGradient = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M21.569 16.997a.667.667 0 0 0-1.334 0c0 2.288-1.9 4.149-4.235 4.149-2.336 0-4.236-1.861-4.236-4.149a.667.667 0 0 0-1.334 0c0 3.023 2.499 5.482 5.57 5.482 3.07 0 5.569-2.459 5.569-5.482Zm-2.15-6.81c-.564 0-1.021.698-1.021 1.56 0 .861.457 1.559 1.02 1.559.564 0 1.02-.698 1.02-1.56 0-.86-.456-1.559-1.02-1.559Zm-6.85 0c-.564 0-1.021.698-1.021 1.56 0 .861.457 1.559 1.02 1.559.564 0 1.021-.698 1.021-1.56 0-.86-.457-1.559-1.02-1.559Zm3.43-6.02C9.476 4.167 4.167 9.475 4.167 16S9.475 27.833 16 27.833c6.525 0 11.833-5.308 11.833-11.833S22.525 4.167 16 4.167Zm0 25C8.74 29.166 2.834 23.26 2.834 16S8.74 2.833 16 2.833 29.166 8.74 29.166 16 23.26 29.166 16 29.166Z"
			fill="url(#FaceMouthClosedOutlineGradient_tsx__a)"
		/>
		<defs>
			<linearGradient
				id="FaceMouthClosedOutlineGradient_tsx__a"
				x1={2.833}
				y1={2.833}
				x2={29.166}
				y2={29.167}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#75B2F0" />
				<stop offset={1} stopColor="#B275F0" />
			</linearGradient>
		</defs>
	</svg>
);
export default FaceMouthClosedOutlineGradient;
